import { primitiveColorTokens } from '@cellula/react-theme-patient';

export function IllustrativeDefault(): JSX.Element {
	return (
		<svg width='500' height='526' viewBox='0 0 500 526' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g id='login-ouline' clipPath='url(#clip0_1066_38923)'>
				<g id='calendar'>
					<g id='calendar_page'>
						<rect y='131.531' width='158.559' height='145.946' rx='16' fill={primitiveColorTokens.primary[600]} />
						<g id='calendar_page_days'>
							<g id='calendar_page_days_row'>
								<path
									id='calendar_page_day'
									d='M48.6487 162.162C48.6487 158.182 51.8755 154.955 55.8559 154.955H68.4685C72.4489 154.955 75.6757 158.182 75.6757 162.162V169.369C75.6757 173.35 72.4489 176.576 68.4685 176.576H55.8559C51.8755 176.576 48.6487 173.35 48.6487 169.369V162.162Z'
									fill={primitiveColorTokens.primary[400]}
								/>
								<path
									id='calendar_page_day_2'
									d='M82.8829 162.162C82.8829 158.182 86.1097 154.955 90.0901 154.955H102.703C106.683 154.955 109.91 158.182 109.91 162.162V169.369C109.91 173.35 106.683 176.576 102.703 176.576H90.0901C86.1097 176.576 82.8829 173.35 82.8829 169.369V162.162Z'
									fill={primitiveColorTokens.primary[400]}
								/>
								<path
									id='calendar_page_day_3'
									d='M117.117 162.162C117.117 158.182 120.344 154.955 124.324 154.955H136.937C140.917 154.955 144.144 158.182 144.144 162.162V169.369C144.144 173.35 140.917 176.576 136.937 176.576H124.324C120.344 176.576 117.117 173.35 117.117 169.369V162.162Z'
									fill={primitiveColorTokens.primary[400]}
								/>
							</g>
							<g id='calendar_page_days_row_2'>
								<path
									id='calendar_page_day_4'
									d='M14.4144 190.991C14.4144 187.01 17.6412 183.784 21.6216 183.784H34.2342C38.2147 183.784 41.4415 187.01 41.4415 190.991V198.198C41.4415 202.179 38.2147 205.405 34.2342 205.405H21.6216C17.6412 205.405 14.4144 202.179 14.4144 198.198V190.991Z'
									fill={primitiveColorTokens.primary[400]}
								/>
								<path
									id='calendar_page_day_5'
									d='M48.6487 190.991C48.6487 187.01 51.8755 183.784 55.8559 183.784H68.4685C72.4489 183.784 75.6757 187.01 75.6757 190.991V198.198C75.6757 202.179 72.4489 205.405 68.4685 205.405H55.8559C51.8755 205.405 48.6487 202.179 48.6487 198.198V190.991Z'
									fill={primitiveColorTokens.primary[400]}
								/>
								<path
									id='calendar_page_day_6'
									d='M82.8829 190.991C82.8829 187.01 86.1097 183.784 90.0901 183.784H102.703C106.683 183.784 109.91 187.01 109.91 190.991V198.198C109.91 202.179 106.683 205.405 102.703 205.405H90.0901C86.1097 205.405 82.8829 202.179 82.8829 198.198V190.991Z'
									fill={primitiveColorTokens.primary[400]}
								/>
								<path
									id='calendar_page_day-selected'
									fillRule='evenodd'
									clipRule='evenodd'
									d='M102.703 185.585H90.0901C87.1048 185.585 84.6847 188.006 84.6847 190.991V198.198C84.6847 201.183 87.1048 203.604 90.0901 203.604H102.703C105.688 203.604 108.108 201.183 108.108 198.198V190.991C108.108 188.006 105.688 185.585 102.703 185.585ZM90.0901 183.784C86.1097 183.784 82.8829 187.01 82.8829 190.991V198.198C82.8829 202.179 86.1097 205.405 90.0901 205.405H102.703C106.683 205.405 109.91 202.179 109.91 198.198V190.991C109.91 187.01 106.683 183.784 102.703 183.784H90.0901Z'
									fill={primitiveColorTokens.primary[800]}
								/>
								<path
									id='calendar_page_day_7'
									d='M117.117 190.991C117.117 187.01 120.344 183.784 124.324 183.784H136.937C140.917 183.784 144.144 187.01 144.144 190.991V198.198C144.144 202.179 140.917 205.405 136.937 205.405H124.324C120.344 205.405 117.117 202.179 117.117 198.198V190.991Z'
									fill={primitiveColorTokens.primary[400]}
								/>
							</g>
							<g id='calendar_page_days_row_3'>
								<path
									id='calendar_page_day_8'
									d='M14.4144 219.82C14.4144 215.839 17.6412 212.613 21.6216 212.613H34.2342C38.2147 212.613 41.4415 215.839 41.4415 219.82V227.027C41.4415 231.007 38.2147 234.234 34.2342 234.234H21.6216C17.6412 234.234 14.4144 231.007 14.4144 227.027V219.82Z'
									fill={primitiveColorTokens.primary[400]}
								/>
								<path
									id='calendar_page_day_9'
									d='M48.6487 219.82C48.6487 215.839 51.8755 212.613 55.8559 212.613H68.4685C72.4489 212.613 75.6757 215.839 75.6757 219.82V227.027C75.6757 231.007 72.4489 234.234 68.4685 234.234H55.8559C51.8755 234.234 48.6487 231.007 48.6487 227.027V219.82Z'
									fill={primitiveColorTokens.primary[400]}
								/>
								<path
									id='calendar_page_day_10'
									d='M82.8829 219.82C82.8829 215.839 86.1097 212.613 90.0901 212.613H102.703C106.683 212.613 109.91 215.839 109.91 219.82V227.027C109.91 231.007 106.683 234.234 102.703 234.234H90.0901C86.1097 234.234 82.8829 231.007 82.8829 227.027V219.82Z'
									fill={primitiveColorTokens.primary[400]}
								/>
								<path
									id='calendar_page_day_11'
									d='M117.117 219.82C117.117 215.839 120.344 212.613 124.324 212.613H136.937C140.917 212.613 144.144 215.839 144.144 219.82V227.027C144.144 231.007 140.917 234.234 136.937 234.234H124.324C120.344 234.234 117.117 231.007 117.117 227.027V219.82Z'
									fill={primitiveColorTokens.primary[400]}
								/>
							</g>
							<g id='calendar_page_days_row_4'>
								<path
									id='calendar_page_day_12'
									d='M14.4144 248.649C14.4144 244.668 17.6412 241.441 21.6216 241.441H34.2342C38.2147 241.441 41.4415 244.668 41.4415 248.649V255.856C41.4415 259.836 38.2147 263.063 34.2342 263.063H21.6216C17.6412 263.063 14.4144 259.836 14.4144 255.856V248.649Z'
									fill={primitiveColorTokens.primary[400]}
								/>
								<path
									id='calendar_page_day_13'
									d='M48.6487 248.649C48.6487 244.668 51.8755 241.441 55.8559 241.441H68.4685C72.4489 241.441 75.6757 244.668 75.6757 248.649V255.856C75.6757 259.836 72.4489 263.063 68.4685 263.063H55.8559C51.8755 263.063 48.6487 259.836 48.6487 255.856V248.649Z'
									fill={primitiveColorTokens.primary[400]}
								/>
								<path
									id='calendar_page_day_14'
									d='M82.8829 248.649C82.8829 244.668 86.1097 241.441 90.0901 241.441H102.703C106.683 241.441 109.91 244.668 109.91 248.649V255.856C109.91 259.836 106.683 263.063 102.703 263.063H90.0901C86.1097 263.063 82.8829 259.836 82.8829 255.856V248.649Z'
									fill={primitiveColorTokens.primary[400]}
								/>
							</g>
						</g>
					</g>
					<g id='calendar_hooks'>
						<path
							id='calendar_hook'
							d='M41.8918 124.324C41.8918 122.334 43.5052 120.721 45.4954 120.721C47.4857 120.721 49.0991 122.334 49.0991 124.324V138.739C49.0991 140.729 47.4857 142.342 45.4954 142.342C43.5052 142.342 41.8918 140.729 41.8918 138.739V124.324Z'
							fill={primitiveColorTokens.primary[800]}
						/>
						<path
							id='calendar_hook_2'
							d='M109.459 124.324C109.459 122.334 111.073 120.721 113.063 120.721C115.053 120.721 116.667 122.334 116.667 124.324V138.739C116.667 140.729 115.053 142.342 113.063 142.342C111.073 142.342 109.459 140.729 109.459 138.739V124.324Z'
							fill={primitiveColorTokens.primary[800]}
						/>
					</g>
				</g>
				<g id='checklist'>
					<rect x='369.369' y='345.045' width='130.631' height='180.18' rx='16' fill={primitiveColorTokens.primary[600]} />
					<g id='checklist_row'>
						<g id='check'>
							<rect x='383.784' y='359.459' width='32.4324' height='32.4324' rx='8' fill={primitiveColorTokens.primary[700]} />
							<path
								id='check_icon'
								fillRule='evenodd'
								clipRule='evenodd'
								d='M409.646 369.633C409.998 369.985 409.998 370.555 409.646 370.907L397.484 383.069C397.132 383.421 396.562 383.421 396.21 383.069L389.453 376.312C389.101 375.961 389.101 375.39 389.453 375.038C389.805 374.687 390.375 374.687 390.727 375.038L396.847 381.158L408.372 369.633C408.724 369.281 409.294 369.281 409.646 369.633Z'
								fill={primitiveColorTokens.primary[400]}
							/>
						</g>
						<path
							id='checklist_row_text'
							d='M427.027 375.675C427.027 371.695 430.254 368.468 434.234 368.468H478.378C482.359 368.468 485.586 371.695 485.586 375.675C485.586 379.656 482.359 382.883 478.378 382.883H434.234C430.254 382.883 427.027 379.656 427.027 375.675Z'
							fill={primitiveColorTokens.primary[400]}
						/>
					</g>
					<g id='checklist_row_2'>
						<g id='check_2'>
							<rect x='383.784' y='399.099' width='32.4324' height='32.4324' rx='8' fill={primitiveColorTokens.primary[700]} />
							<path
								id='check_icon_2'
								fillRule='evenodd'
								clipRule='evenodd'
								d='M409.646 409.273C409.998 409.624 409.998 410.195 409.646 410.547L397.484 422.709C397.132 423.061 396.562 423.061 396.21 422.709L389.453 415.952C389.101 415.6 389.101 415.03 389.453 414.678C389.805 414.326 390.375 414.326 390.727 414.678L396.847 420.798L408.372 409.273C408.724 408.921 409.294 408.921 409.646 409.273Z'
								fill={primitiveColorTokens.primary[400]}
							/>
						</g>
						<path
							id='checklist_row_text_2'
							d='M427.027 415.315C427.027 411.335 430.254 408.108 434.234 408.108H478.378C482.359 408.108 485.586 411.335 485.586 415.315C485.586 419.296 482.359 422.522 478.378 422.522H434.234C430.254 422.522 427.027 419.296 427.027 415.315Z'
							fill={primitiveColorTokens.primary[400]}
						/>
					</g>
					<g id='checklist_row_3'>
						<g id='check_3'>
							<rect x='383.784' y='438.739' width='32.4324' height='32.4324' rx='8' fill={primitiveColorTokens.primary[700]} />
							<path
								id='check_icon_3'
								fillRule='evenodd'
								clipRule='evenodd'
								d='M409.646 448.912C409.998 449.264 409.998 449.835 409.646 450.186L397.484 462.349C397.132 462.7 396.562 462.7 396.21 462.349L389.453 455.592C389.101 455.24 389.101 454.67 389.453 454.318C389.805 453.966 390.375 453.966 390.727 454.318L396.847 460.437L408.372 448.912C408.724 448.56 409.294 448.56 409.646 448.912Z'
								fill={primitiveColorTokens.primary[400]}
							/>
						</g>
						<path
							id='checklist_row_text_3'
							d='M427.027 454.955C427.027 450.974 430.254 447.748 434.234 447.748H478.378C482.359 447.748 485.586 450.974 485.586 454.955C485.586 458.935 482.359 462.162 478.378 462.162H434.234C430.254 462.162 427.027 458.935 427.027 454.955Z'
							fill={primitiveColorTokens.primary[400]}
						/>
					</g>
					<g id='checklist_row_4'>
						<g id='check_4'>
							<rect x='383.784' y='478.378' width='32.4324' height='32.4324' rx='8' fill={primitiveColorTokens.primary[700]} />
							<path
								id='check_icon_4'
								fillRule='evenodd'
								clipRule='evenodd'
								d='M409.646 488.552C409.998 488.904 409.998 489.474 409.646 489.826L397.484 501.988C397.132 502.34 396.562 502.34 396.21 501.988L389.453 495.231C389.101 494.88 389.101 494.309 389.453 493.957C389.805 493.606 390.375 493.606 390.727 493.957L396.847 500.077L408.372 488.552C408.724 488.2 409.294 488.2 409.646 488.552Z'
								fill={primitiveColorTokens.primary[400]}
							/>
						</g>
						<path
							id='checklist_row_text_4'
							d='M427.027 494.594C427.027 490.614 430.254 487.387 434.234 487.387H478.378C482.359 487.387 485.586 490.614 485.586 494.594C485.586 498.575 482.359 501.802 478.378 501.802H434.234C430.254 501.802 427.027 498.575 427.027 494.594Z'
							fill={primitiveColorTokens.primary[400]}
						/>
					</g>
				</g>
				<g id='circled-doctor_frame'>
					<g clipPath='url(#clip1_1066_38923)'>
						<rect x='28.8289' y='312.613' width='197.297' height='197.297' rx='98.6487' fill={primitiveColorTokens.primary[500]} />
						<g id='circled-doctor' clipPath='url(#clip2_1066_38923)'>
							<path
								id='circled-doctor_hair'
								d='M142.829 459.855C142.829 459.855 102.874 463.234 95.8018 462.008C88.7297 460.783 81.081 451.864 81.081 451.864C81.081 451.864 65.3693 455.549 57.3783 440.792C57.3783 440.792 73.9819 439.261 67.5225 427.576C61.063 415.891 52.4594 407.9 59.2252 394.99C65.9909 382.081 74.9008 385.468 73.3603 374.09C73.3603 374.09 69.9819 366.099 75.2072 359.027C80.4324 351.954 85.7927 354.108 88.5585 349.189C91.3243 344.27 100.721 331.675 127.153 333.513C153.586 335.351 152.378 347.027 160.351 349.189C168.324 351.351 181.568 359.999 182.793 372.558C184.018 385.117 180.027 392.531 184.595 395.612C189.162 398.693 194.432 404.828 191.973 413.126C189.513 421.423 192.279 431.882 202.117 430.342C202.117 430.342 199.045 442.054 180.595 440.792C180.64 440.792 174.495 458.008 142.829 459.855Z'
								fill={primitiveColorTokens.primary[800]}
							/>
							<path
								id='circled-doctor_robe'
								d='M195.601 510.811C190.492 500.264 184.363 490.322 177.038 481.349C174.406 477.426 171.169 473.847 167.433 470.702C157.09 462 142.982 456.648 127.469 456.648C106.36 456.648 87.8607 466.542 77.9218 481.317C70.5879 490.292 64.4472 500.246 59.328 510.811H195.601Z'
								fill={primitiveColorTokens.primary[700]}
							/>
							<path
								id='circled-doctor_head'
								d='M169.122 417.808C163.178 439.769 146.774 455.55 127.468 455.55C103.148 455.55 83.4324 430.506 83.4324 399.613C83.4324 368.72 103.148 343.676 127.468 343.676C151.789 343.676 171.504 368.72 171.504 399.613C171.504 399.974 171.502 400.334 171.496 400.694C172.352 400.439 173.209 400.429 174.012 400.707C176.992 401.742 178.095 406.364 176.475 411.032C175.028 415.201 171.898 417.996 169.122 417.808Z'
								fill={primitiveColorTokens.primary[300]}
							/>
							<path
								id='circled-doctor_eye'
								d='M108.414 408.252C109.564 408.252 110.496 407.321 110.496 406.171C110.496 405.022 109.564 404.09 108.414 404.09C107.265 404.09 106.333 405.022 106.333 406.171C106.333 407.321 107.265 408.252 108.414 408.252Z'
								fill={primitiveColorTokens.primary[900]}
							/>
							<path
								id='circled-doctor_eye_2'
								d='M146.514 408.252C147.663 408.252 148.595 407.321 148.595 406.171C148.595 405.022 147.663 404.09 146.514 404.09C145.364 404.09 144.432 405.022 144.432 406.171C144.432 407.321 145.364 408.252 146.514 408.252Z'
								fill={primitiveColorTokens.primary[900]}
							/>
							<path
								id='circled-doctor_eyebrow (Stroke)'
								fillRule='evenodd'
								clipRule='evenodd'
								d='M157.776 396.061C157.777 396.061 157.777 396.061 157.216 396.766L157.777 396.061C158.167 396.371 158.231 396.938 157.921 397.327C157.612 397.716 157.046 397.781 156.657 397.472C156.656 397.472 156.656 397.471 156.655 397.471M156.655 397.471L156.649 397.466C156.641 397.46 156.626 397.449 156.606 397.434C156.565 397.404 156.501 397.357 156.413 397.297C156.237 397.178 155.968 397.005 155.612 396.806C154.9 396.408 153.842 395.905 152.481 395.504C149.768 394.706 145.831 394.308 140.989 395.987C140.519 396.15 140.006 395.901 139.843 395.431C139.68 394.96 139.928 394.447 140.399 394.284C145.638 392.468 149.962 392.885 152.99 393.776C154.499 394.22 155.681 394.78 156.492 395.234C156.898 395.46 157.211 395.661 157.427 395.808C157.535 395.881 157.618 395.942 157.677 395.985C157.706 396.007 157.729 396.024 157.746 396.037L157.766 396.053L157.773 396.058L157.775 396.06L157.776 396.061'
								fill={primitiveColorTokens.primary[600]}
							/>
							<path
								id='circled-doctor_eyebrow (Stroke)_2'
								fillRule='evenodd'
								clipRule='evenodd'
								d='M97.7117 396.766L97.1507 396.061C96.7614 396.371 96.697 396.938 97.0068 397.327C97.3164 397.716 97.8827 397.781 98.272 397.472C98.2723 397.471 98.2725 397.471 98.2727 397.471L97.7117 396.766ZM98.2713 397.472L98.2791 397.466C98.2874 397.46 98.3017 397.449 98.322 397.434C98.3627 397.404 98.4273 397.357 98.5153 397.297C98.6911 397.178 98.9597 397.005 99.3156 396.806C100.028 396.408 101.086 395.905 102.447 395.504C105.16 394.706 109.097 394.308 113.939 395.987C114.409 396.15 114.922 395.901 115.085 395.431C115.248 394.96 114.999 394.447 114.529 394.284C109.29 392.468 104.966 392.885 101.938 393.776C100.429 394.22 99.2466 394.78 98.4359 395.234C98.0303 395.46 97.7169 395.661 97.5011 395.808C97.3932 395.881 97.3096 395.942 97.251 395.985C97.2217 396.007 97.1987 396.024 97.1819 396.037L97.1616 396.053L97.155 396.058L97.1526 396.06L97.1516 396.061C97.1511 396.061 97.1507 396.061 97.7117 396.766M98.2709 397.472C98.2706 397.473 98.2708 397.473 98.2713 397.472L98.2709 397.472Z'
								fill={primitiveColorTokens.primary[600]}
							/>
							<path
								id='circled-doctor_mouth (Stroke)'
								fillRule='evenodd'
								clipRule='evenodd'
								d='M119.825 435.261C120.084 434.836 120.638 434.701 121.063 434.96C123.551 436.473 126.325 437.456 129.211 437.846C129.704 437.913 130.05 438.366 129.983 438.859C129.916 439.352 129.463 439.698 128.97 439.631C125.837 439.208 122.827 438.142 120.127 436.499C119.701 436.241 119.566 435.687 119.825 435.261Z'
								fill={primitiveColorTokens.primary[600]}
							/>
							<path
								id='circled-doctor_nose (Stroke)'
								fillRule='evenodd'
								clipRule='evenodd'
								d='M130.143 405.982C130.61 405.812 131.127 406.053 131.297 406.521L136.081 419.683C136.176 419.945 136.145 420.235 135.997 420.471C135.849 420.706 135.6 420.86 135.323 420.887L127.963 421.617C127.468 421.666 127.027 421.305 126.977 420.809C126.928 420.314 127.29 419.873 127.785 419.824L133.992 419.209L129.604 407.136C129.434 406.669 129.675 406.152 130.143 405.982Z'
								fill={primitiveColorTokens.primary[600]}
							/>
							<path
								id='circled-doctor_fringe'
								d='M176.027 424.198C176.027 424.198 169.883 416.514 168.964 408.829C168.045 401.144 167.73 399.91 163.117 393.766C158.505 387.622 158.198 384.234 159.126 377.162C160.054 370.09 149.288 359.334 149.288 359.334C149.288 359.334 138.838 374.09 116.397 381.775C93.9551 389.46 84.5317 401.307 86.0632 425.018L68.7479 402.37C68.7479 402.37 79.5587 348.316 107.793 339.045C136.027 329.775 154.514 344.279 162.162 361.18C169.811 378.081 179.108 402.703 180.64 411.901C182.171 421.099 176.027 424.198 176.027 424.198Z'
								fill={primitiveColorTokens.primary[800]}
							/>
							<path
								id='circled-doctor_neck'
								d='M139.477 457.747C140.236 457.887 140.993 458.04 141.748 458.207C141.794 458.402 141.818 458.601 141.82 458.802C141.82 460.232 140.597 461.543 138.56 462.566L126.973 487.135L116.275 462.519C114.293 461.503 113.108 460.21 113.108 458.802C113.11 458.601 113.134 458.402 113.18 458.207C113.935 458.04 114.692 457.887 115.45 457.747V449.027H139.477V457.747Z'
								fill={primitiveColorTokens.primary[300]}
							/>
							<g id='circled-doctor_robe_lines'>
								<path
									d='M142.311 458.426C142.847 458.742 143.025 459.433 142.709 459.968C141.797 461.514 140.482 462.778 138.909 463.629L128.649 487.245L128.633 511.712H126.38L126.396 487.493L116.019 463.628C114.449 462.776 113.138 461.512 112.228 459.968C111.912 459.432 112.091 458.742 112.627 458.426C113.163 458.11 113.853 458.289 114.169 458.825C114.926 460.11 116.045 461.144 117.386 461.799C117.627 461.916 117.818 462.116 117.925 462.362L127.468 484.31L137.003 462.362C137.11 462.115 137.302 461.915 137.544 461.798C138.888 461.145 140.01 460.111 140.769 458.824C141.085 458.288 141.775 458.11 142.311 458.426Z'
									fill={primitiveColorTokens.primary[600]}
								/>
								<path
									d='M109.671 511.712L108.335 506.709L116.781 493.769C116.996 493.44 117.023 493.021 116.853 492.666C116.682 492.311 116.339 492.071 115.947 492.033L107.124 491.174L97.8161 465.331C97.6053 464.746 96.9601 464.442 96.375 464.653C95.7898 464.864 95.4863 465.509 95.6971 466.094L105.247 492.608C105.394 493.017 105.764 493.305 106.197 493.347L113.879 494.095L106.174 505.899C105.999 506.166 105.946 506.496 106.029 506.805L107.339 511.712H109.671Z'
									fill={primitiveColorTokens.primary[600]}
								/>
								<path
									d='M147.597 511.712L148.908 506.805C148.99 506.496 148.938 506.166 148.763 505.899L141.058 494.095L148.74 493.347C149.173 493.305 149.543 493.017 149.69 492.608L159.24 466.094C159.451 465.509 159.147 464.864 158.562 464.653C157.977 464.442 157.332 464.746 157.121 465.331L147.813 491.174L138.99 492.033C138.598 492.071 138.255 492.311 138.084 492.666C137.914 493.021 137.941 493.44 138.156 493.769L146.602 506.709L145.266 511.712H147.597Z'
									fill={primitiveColorTokens.primary[600]}
								/>
							</g>
						</g>
					</g>
				</g>
				<g id='computer'>
					<g id='computer_screen'>
						<g clipPath='url(#clip3_1066_38923)'>
							<path
								d='M134.234 59.2432C134.234 50.4066 141.398 43.2432 150.234 43.2432H438.955C447.792 43.2432 454.955 50.4066 454.955 59.2432V240.54H134.234V59.2432Z'
								fill={primitiveColorTokens.primary[400]}
							/>
							<g id='computer_doctor' clipPath='url(#clip4_1066_38923)'>
								<path
									id='computer_doctor_robe'
									d='M358.271 234.234C354.115 226.859 349.395 219.858 344.042 213.373C341.485 209.68 338.387 206.301 334.838 203.315C324.496 194.613 310.387 189.261 294.874 189.261C273.878 189.261 255.464 199.049 245.487 213.693C240.243 220.089 235.609 226.98 231.521 234.234H358.271Z'
									fill={primitiveColorTokens.primary[100]}
								/>
								<path
									id='computer_doctor_face'
									d='M338.901 132.597C338.907 132.231 338.91 131.864 338.91 131.496C338.91 100.602 319.194 75.5586 294.874 75.5586C270.553 75.5586 250.838 100.602 250.838 131.496C250.838 131.866 250.84 132.236 250.846 132.605C249.987 132.347 249.126 132.336 248.319 132.616C245.339 133.65 244.237 138.272 245.857 142.94C247.307 147.118 250.446 149.916 253.226 149.715C257.891 166.925 268.981 180.335 282.856 185.324V190.362C282.1 190.501 281.346 190.654 280.595 190.82C280.544 191.014 280.519 191.214 280.523 191.414C280.523 192.816 281.703 194.105 283.676 195.121L294.378 219.739L305.988 195.148C308.017 194.122 309.234 192.818 309.234 191.414C309.234 191.214 309.207 191.014 309.153 190.82C308.401 190.654 307.647 190.501 306.892 190.361V185.324C320.768 180.335 331.859 166.921 336.523 149.707C339.302 149.906 342.44 147.108 343.889 142.932C345.509 138.264 344.407 133.642 341.427 132.608C340.621 132.328 339.76 132.339 338.901 132.597Z'
									fill={primitiveColorTokens.primary[600]}
								/>
								<path
									id='computer_doctor_hair'
									d='M263.063 110.342C261.681 113.768 261.27 117.508 261.874 121.153C261.874 121.153 269.775 111.36 278.928 108.54C278.883 111.702 272.423 121.36 272.423 121.36C272.423 121.36 291.748 121.153 308.459 104.072C308.459 104.072 311.838 115.54 323.919 113.423C323.919 113.423 317.405 105.693 318.423 99.594C323.982 101.981 336.261 120.216 338.955 132.63C338.955 132.63 343.459 121.351 342.63 111.189C342.045 103.873 335.306 74.3688 311.919 68.2697C288.531 62.1706 263.369 74.7742 255 88.2877C247.703 99.9995 246.982 110.99 247.991 118.72C248.614 123.421 249.568 128.072 250.847 132.639C250.847 132.639 255.126 112.675 263.063 110.342Z'
									fill={primitiveColorTokens.primary[900]}
								/>
								<path
									id='computer_doctor_eye'
									d='M275.82 140.144C276.969 140.144 277.901 139.213 277.901 138.063C277.901 136.914 276.969 135.982 275.82 135.982C274.671 135.982 273.739 136.914 273.739 138.063C273.739 139.213 274.671 140.144 275.82 140.144Z'
									fill={primitiveColorTokens.primary[1000]}
								/>
								<path
									id='computer_doctor_eye_2'
									d='M313.928 140.144C315.077 140.144 316.009 139.213 316.009 138.063C316.009 136.914 315.077 135.982 313.928 135.982C312.778 135.982 311.847 136.914 311.847 138.063C311.847 139.213 312.778 140.144 313.928 140.144Z'
									fill={primitiveColorTokens.primary[1000]}
								/>
								<path
									id='computer_doctor_nose'
									fillRule='evenodd'
									clipRule='evenodd'
									d='M297.548 137.864C298.016 137.695 298.532 137.936 298.702 138.403L303.486 151.566C303.581 151.827 303.55 152.118 303.402 152.353C303.254 152.589 303.005 152.742 302.728 152.77L295.368 153.5C294.873 153.549 294.432 153.187 294.383 152.692C294.333 152.197 294.695 151.756 295.19 151.707L301.397 151.091L297.009 139.019C296.839 138.551 297.08 138.034 297.548 137.864Z'
									fill={primitiveColorTokens.primary[900]}
								/>
								<path
									id='computer_doctor_eyebrow'
									fillRule='evenodd'
									clipRule='evenodd'
									d='M325.191 127.943C325.191 127.943 325.192 127.944 324.631 128.649L325.192 127.944C325.581 128.253 325.645 128.82 325.336 129.21C325.026 129.598 324.461 129.663 324.071 129.355C324.071 129.355 324.071 129.354 324.07 129.354L324.07 129.354L324.063 129.349C324.055 129.342 324.041 129.331 324.02 129.316C323.98 129.286 323.915 129.24 323.827 129.18C323.651 129.06 323.383 128.888 323.027 128.689C322.315 128.29 321.257 127.788 319.896 127.388C317.183 126.591 313.246 126.195 308.404 127.878C307.934 128.041 307.421 127.793 307.257 127.323C307.094 126.853 307.342 126.339 307.812 126.176C313.051 124.355 317.376 124.77 320.404 125.659C321.913 126.103 323.096 126.663 323.906 127.116C324.312 127.343 324.625 127.544 324.841 127.69C324.949 127.764 325.033 127.824 325.091 127.867C325.121 127.889 325.144 127.907 325.16 127.919L325.181 127.935L325.187 127.94L325.19 127.942L325.191 127.943Z'
									fill={primitiveColorTokens.primary[900]}
								/>
								<path
									id='computer_doctor_eyebrow_2'
									fillRule='evenodd'
									clipRule='evenodd'
									d='M265.126 128.649L264.565 127.944C264.176 128.254 264.112 128.821 264.422 129.21C264.732 129.599 265.298 129.663 265.687 129.354L265.686 129.354L265.686 129.354C265.686 129.355 265.686 129.355 265.686 129.355M265.126 128.649C264.565 127.944 264.565 127.944 264.566 127.943L264.567 127.943L264.569 127.941L264.576 127.936L264.596 127.92C264.613 127.907 264.636 127.889 264.665 127.868C264.723 127.824 264.807 127.764 264.915 127.691C265.13 127.544 265.443 127.343 265.849 127.116C266.659 126.663 267.84 126.103 269.348 125.659C272.374 124.769 276.696 124.355 281.935 126.176C282.405 126.339 282.654 126.853 282.491 127.323C282.327 127.793 281.814 128.041 281.344 127.878C276.502 126.195 272.567 126.591 269.857 127.388C268.497 127.788 267.44 128.29 266.729 128.688C266.373 128.887 266.105 129.06 265.93 129.18C265.842 129.239 265.777 129.286 265.737 129.316C265.716 129.331 265.702 129.342 265.694 129.348L265.686 129.354'
									fill={primitiveColorTokens.primary[900]}
								/>
								<g id='computer_doctor_robe_lines'>
									<path
										d='M281.572 191.435C281.255 190.9 280.565 190.723 280.03 191.04C279.494 191.357 279.318 192.048 279.635 192.583C280.548 194.125 281.862 195.388 283.433 196.24L293.727 219.934C293.743 220.029 293.771 220.122 293.81 220.209L293.801 234.234H296.054L296.063 219.753L306.277 196.244C307.861 195.397 309.188 194.133 310.111 192.586C310.43 192.052 310.255 191.361 309.721 191.042C309.187 190.723 308.496 190.898 308.177 191.432C307.407 192.723 306.273 193.758 304.918 194.408C304.674 194.525 304.48 194.726 304.372 194.975L294.856 216.88L285.339 194.975C285.232 194.729 285.041 194.529 284.8 194.411C283.456 193.756 282.334 192.721 281.572 191.435Z'
										fill={primitiveColorTokens.primary[500]}
									/>
									<path
										d='M310.69 234.234H313.379L308.463 226.698L316.145 225.95C316.578 225.907 316.948 225.62 317.095 225.21L326.645 198.697C326.856 198.112 326.552 197.467 325.967 197.256C325.382 197.045 324.737 197.349 324.526 197.934L315.218 223.777L306.395 224.636C306.003 224.674 305.66 224.914 305.489 225.269C305.319 225.624 305.346 226.042 305.561 226.372L310.69 234.234Z'
										fill={primitiveColorTokens.primary[500]}
									/>
									<path
										d='M276.369 234.234H279.058L284.186 226.372C284.401 226.042 284.428 225.624 284.258 225.269C284.087 224.914 283.744 224.674 283.352 224.636L274.529 223.777L265.221 197.934C265.011 197.349 264.365 197.045 263.78 197.256C263.195 197.467 262.892 198.112 263.102 198.697L272.652 225.21C272.799 225.62 273.169 225.907 273.602 225.95L281.285 226.698L276.369 234.234Z'
										fill={primitiveColorTokens.primary[500]}
									/>
								</g>
								<path
									id='computer_doctor_mouth'
									fillRule='evenodd'
									clipRule='evenodd'
									d='M287.482 169.417C287.705 168.972 288.246 168.791 288.691 169.014C290.328 169.833 292.655 170.27 295.045 170.27C297.435 170.27 299.762 169.833 301.399 169.014C301.844 168.791 302.385 168.972 302.608 169.417C302.83 169.862 302.65 170.403 302.205 170.626C300.238 171.609 297.61 172.072 295.045 172.072C292.48 172.072 289.852 171.609 287.885 170.626C287.44 170.403 287.26 169.862 287.482 169.417Z'
									fill={primitiveColorTokens.primary[900]}
								/>
							</g>
						</g>
						<path
							d='M138.234 59.2432C138.234 52.6157 143.607 47.2432 150.234 47.2432H438.955C445.582 47.2432 450.955 52.6157 450.955 59.2432V236.54H138.234V59.2432Z'
							stroke={primitiveColorTokens.primary[700]}
							strokeWidth='8'
						/>
					</g>
					<path
						id='computer_bottom'
						d='M121.622 247.748C121.622 243.767 124.848 240.541 128.829 240.541H459.459C463.44 240.541 466.667 243.767 466.667 247.748V251.351C466.667 255.332 463.44 258.559 459.459 258.559H128.829C124.848 258.559 121.622 255.332 121.622 251.351V247.748Z'
						fill={primitiveColorTokens.primary[800]}
					/>
					<path
						id='computer_line'
						d='M238.739 249.549C238.739 251.042 239.949 252.252 241.441 252.252H346.847C348.34 252.252 349.55 251.042 349.55 249.549C349.55 248.057 348.34 246.847 346.847 246.847H241.441C239.949 246.847 238.739 248.057 238.739 249.549Z'
						fill={primitiveColorTokens.primary[600]}
					/>
				</g>
				<g id='speach-bubble'>
					<path
						d='M44.1442 16C44.1442 7.16346 51.3076 0 60.1442 0H220.937C229.774 0 236.937 7.16344 236.937 16V82.8829H60.1442C51.3076 82.8829 44.1442 75.7194 44.1442 66.8829V16Z'
						fill={primitiveColorTokens.primary[100]}
					/>
					<g id='speach-bubble_text'>
						<path
							id='speach-bubble_text_row'
							d='M65.7657 28.8288C65.7657 24.8484 68.9925 21.6216 72.973 21.6216H208.108C212.089 21.6216 215.315 24.8484 215.315 28.8288C215.315 32.8092 212.089 36.036 208.108 36.036H72.973C68.9925 36.036 65.7657 32.8092 65.7657 28.8288Z'
							fill={primitiveColorTokens.primary[500]}
						/>
						<path
							id='speach-bubble_text_row_2'
							d='M65.7657 54.0541C65.7657 50.0737 68.9925 46.8469 72.973 46.8469H192.86C196.84 46.8469 200.067 50.0737 200.067 54.0541C200.067 58.0346 196.84 61.2613 192.86 61.2613H72.9729C68.9925 61.2613 65.7657 58.0346 65.7657 54.0541Z'
							fill={primitiveColorTokens.primary[500]}
						/>
					</g>
				</g>
				<g id='speach-bubble_2'>
					<path
						d='M195.495 299.784C195.495 290.947 202.659 283.784 211.495 283.784H436.252C445.089 283.784 452.252 290.947 452.252 299.784V375.892C452.252 384.728 445.089 391.892 436.252 391.892H195.495V299.784Z'
						fill={primitiveColorTokens.primary[100]}
					/>
					<g id='speach-bubble_text_2'>
						<path
							id='speach-bubble_text_row_3'
							d='M217.117 312.612C217.117 308.632 220.344 305.405 224.324 305.405H423.423C427.404 305.405 430.631 308.632 430.631 312.612C430.631 316.593 427.404 319.82 423.423 319.82H224.324C220.344 319.82 217.117 316.593 217.117 312.612Z'
							fill={primitiveColorTokens.primary[500]}
						/>
						<path
							id='speach-bubble_text_row_4'
							d='M217.117 337.838C217.117 333.857 220.344 330.631 224.324 330.631H379.078C383.059 330.631 386.286 333.857 386.286 337.838C386.286 341.818 383.059 345.045 379.078 345.045H224.324C220.344 345.045 217.117 341.818 217.117 337.838Z'
							fill={primitiveColorTokens.primary[500]}
						/>
						<path
							id='speach-bubble_text_row_5'
							d='M217.117 363.063C217.117 359.082 220.344 355.856 224.324 355.856H397.966C401.946 355.856 405.173 359.082 405.173 363.063C405.173 367.043 401.946 370.27 397.966 370.27H224.324C220.344 370.27 217.117 367.043 217.117 363.063Z'
							fill={primitiveColorTokens.primary[500]}
						/>
					</g>
				</g>
			</g>
			<defs>
				<clipPath id='clip0_1066_38923'>
					<rect width='500' height='525.225' fill='white' />
				</clipPath>
				<clipPath id='clip1_1066_38923'>
					<rect x='28.8289' y='312.613' width='197.297' height='197.297' rx='98.6487' fill='white' />
				</clipPath>
				<clipPath id='clip2_1066_38923'>
					<rect width='145.405' height='181' fill='white' transform='translate(56.7568 333.333)' />
				</clipPath>
				<clipPath id='clip3_1066_38923'>
					<path
						d='M134.234 59.2432C134.234 50.4066 141.398 43.2432 150.234 43.2432H438.955C447.792 43.2432 454.955 50.4066 454.955 59.2432V240.54H134.234V59.2432Z'
						fill='white'
					/>
				</clipPath>
				<clipPath id='clip4_1066_38923'>
					<rect width='139.64' height='179.279' fill='white' transform='translate(225.225 66.6665)' />
				</clipPath>
			</defs>
		</svg>
	);
}
